import { createAction, props } from "@ngrx/store";

export const showAlertAction = createAction(
  "[Alert] show alert",
  props<{
    payload: {
      message: string;
      title: string;
      type: string;
      spaceId?: number;
      bookingId?: number;
      employeeId?: number;
      deleteCompanyId?: number;
      editCompanyId?: number;
      editSpaceId?: number;
      editCoworkingId?: number;
      optionOkText?: string;
      optionCancelText?: string;
      action?: string;
    };
  }>()
);

export const closeAlertAction = createAction(
  "[Alert] close alert",
  props<{}>()
);

export const okAlertAction = createAction(
  "[Alert] ok alert",
  props<{ action }>()
);
